import React, { useState } from "react";
import classNames from "classnames";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBurgerSoda, faPlus } from "@fortawesome/pro-regular-svg-icons";
import { IFoodOrderingProduct, INewIVariant } from "pages/guest/Customer/ClientPortal/FoodOrdering/Menu";
import { displayCurrency } from "helpers/Helpers";
import "./foodOrderingProductCard.scss";
import AddRemoveButton from "./AddRemoveButton";
import { ICartLineItem } from "redux/reducers/customer/models/cart";

interface IProductCardProps {
  product: IFoodOrderingProduct;
  variant: INewIVariant;
  onRemoveLineItem: (line_item: ICartLineItem) => void;
  onHandleQuantityChange: (line_item: ICartLineItem) => void;
  onAddToBag?: (product: any, variant_id: number, variant?: INewIVariant) => void;
  quantity: number;
  line_item: ICartLineItem;
  onShowProductDetailsModal: () => void;
  showProductImages: boolean;
  facility_id?: number;
}

const FoodOrderingProductCard: React.FC<IProductCardProps> = props => {
  const { product, variant, quantity, line_item, showProductImages } = props;

  function removeLineItem(line_item: ICartLineItem) {
    props.onRemoveLineItem(line_item);
  }

  function handleQuantityChange(line_item: ICartLineItem) {
    props.onHandleQuantityChange(line_item);
  }

  function handleShowProductDetails() {
    props.onShowProductDetailsModal();
  }

  function addToBag(product: any, variant_id: number, variant?: INewIVariant) {
    props.onAddToBag(product, variant_id, variant);
  }

  function getVariantPrice(variant: INewIVariant): number {
      if (!variant) {
        return 0;
      }
      let price = variant.price;
      if (variant.inventory_item) {
        const level = variant.inventory_item.inventory_levels?.find(level => level.facility_id === props.facility_id);
        if (level && level.price_override) {
          price = Number(level.price_override);
        }
      }
  
      return price;
    }

  return (
    <>
      <div className="food-ordering-item-container">
        {showProductImages &&
          (product?.default_image?.source ? (
            <div onClick={handleShowProductDetails} className="food-ordering-item-picture-container">
              <img src={product?.default_image?.source} className={classNames("food-ordering-item-picture", {})} />
            </div>
          ) : (
            <div
              onClick={handleShowProductDetails}
              className="food-ordering-item-picture-container food-ordering-item-no-picture-container"
            >
              <div className="food-ordering-item-no-picture">
                <FontAwesomeIcon fixedWidth className="food-ordering-item-no-picture-icon" icon={faBurgerSoda} />
              </div>
            </div>
          ))}

        <div className="food-ordering-item">
          <div className="food-ordering-item-info-container">
            <div>
              <p className="food-ordering-item-title">{variant?.title}</p>
              <p className="food-ordering-item-description">{product?.description}</p>
            </div>

            <div className="food-ordering-item-price-container">
              <div className="food-ordering-item-price">{displayCurrency("cad", getVariantPrice(variant))}</div>

              <div>
                <AddRemoveButton
                  product={product}
                  variant={variant}
                  quantity={quantity}
                  line_item={line_item}
                  variant_id={variant.id}
                  onRemoveLineItem={() => removeLineItem(line_item)}
                  onHandleQuantityChange={() => handleQuantityChange(line_item)}
                  onAddToBag={() => addToBag(product, variant.id, variant)}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default FoodOrderingProductCard;
